// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

var hoverColour = Theme__Color$PrezzeeRibbon.Personal.primaryRed;

var linkColour = Theme__Color$PrezzeeRibbon.Personal.charcoal;

var Theme = {
  hoverColour: hoverColour,
  linkColour: linkColour
};

export {
  Theme ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
